(() => {
  const variantContainers = [
    '[data-fsm-product-variant-data]',
    '[data-fsm-product-delivery]'
  ].join(', ');

  let scheduled = false;

  const selectedVariantId = (productPage, preferredVariantId = null) => {
    if (preferredVariantId) return String(preferredVariantId);

    const form = productPage?.querySelector('form[action*="/cart/add"]:not(.product-form-installment)');
    return form?.querySelector('[name="id"]')?.value || null;
  };

  const updateVariantContent = (productPage, preferredVariantId = null) => {
    const variantId = selectedVariantId(productPage, preferredVariantId);
    if (!variantId) return;

    productPage.querySelectorAll(variantContainers).forEach((container) => {
      container.querySelectorAll('[data-fsm-variant-id]').forEach((item) => {
        item.hidden = item.dataset.fsmVariantId !== variantId;
      });
    });

    document.querySelectorAll('[data-fsm-variant-row]').forEach((row) => {
      const selected = row.dataset.fsmVariantRow === variantId;
      const link = row.matches('a') ? row : row.querySelector('a');
      row.classList.toggle('is-selected', selected);
      if (selected) link?.setAttribute('aria-current', 'page');
      else link?.removeAttribute('aria-current');
    });

    const delivery = productPage.querySelector(
      `[data-fsm-product-delivery] [data-fsm-variant-id="${CSS.escape(variantId)}"]`
    );
    const addButton = productPage.querySelector('[data-js-product-add-to-cart]');
    const addButtonText = addButton?.querySelector('[data-js-product-add-to-cart-text]');
    if (delivery && addButton && addButtonText) {
      const unavailable = delivery.dataset.fsmDeliveryState === 'unavailable';
      addButton.classList.toggle('disabled', unavailable);
      addButton.disabled = unavailable;
      const expectedLabel = unavailable ? 'Alternativen ansehen' : 'In den Warenkorb';
      if (addButtonText.textContent.trim() !== expectedLabel) addButtonText.textContent = expectedLabel;
    }
  };

  const updateInformationVisibility = () => {
    const information = document.querySelector('.fsm-product-information');
    const content = information?.querySelector('.fsm-product-information__content');
    const aside = information?.querySelector('.fsm-product-information__aside');
    if (!information) return;

    const contentEmpty = !content || content.children.length === 0;
    const asideEmpty = !aside || aside.children.length === 0;
    content?.classList.toggle('is-empty', contentEmpty);
    aside?.classList.toggle('is-empty', asideEmpty);
    information.classList.toggle('is-empty', contentEmpty && asideEmpty);
  };

  const arrangeProductLayout = (productPage) => {
    if (!productPage) return;

    let gallery = productPage.querySelector(':scope > .product-gallery');
    const mediaColumn = productPage.querySelector(':scope > .fsm-product-media-column');
    if (!gallery && mediaColumn) gallery = mediaColumn.querySelector('.product-gallery');

    const productText = productPage.querySelector(':scope > .product-text');
    if (!gallery || !productText) return;

    const description = productText?.querySelector('.product__description')
      || productPage?.querySelector(':scope > .fsm-product-editorial-stack .product__description');
    const workshopBlock = productText?.querySelector('.fsm-block--workshop')
      || productPage?.querySelector(':scope > .fsm-product-editorial-stack .fsm-block--workshop');
    const guide = productPage.querySelector('.fsm-guide-card')
      || document.querySelector('.fsm-product-information__aside > .fsm-guide-card');
    const compatibility = productPage.querySelector(
      'section[aria-labelledby^="fsm-compatibility-title-"]'
    ) || document.querySelector(
      '.fsm-product-information__content > section[aria-labelledby^="fsm-compatibility-title-"]'
    );
    const verdict = productPage.querySelector('.fsm-workshop-verdict')
      || document.querySelector('.fsm-product-information__content > .fsm-workshop-verdict');
    const technical = productPage?.querySelector('.fsm-product-technical')
      || document.querySelector('.fsm-product-technical');
    const variants = productPage?.querySelector('#alleausfuehrungen')
      || document.querySelector('#alleausfuehrungen');
    const recommendations = [...document.querySelectorAll('.fsm-product-recommendation-row')];
    const dataStack = productPage?.querySelector('.fsm-product-data-stack');

    let editorialStack = productText.querySelector(':scope > .fsm-product-editorial-stack')
      || productPage.querySelector(':scope > .fsm-product-editorial-stack');
    if (!editorialStack) {
      editorialStack = document.createElement('div');
      editorialStack.className = 'fsm-product-editorial-stack';
    }

    if (productText.nextElementSibling !== editorialStack) {
      productText.insertAdjacentElement('afterend', editorialStack);
    }

    const editorialBlocks = [
      description,
      technical,
      variants,
      workshopBlock,
      compatibility,
      ...recommendations,
      guide,
      verdict
    ];

    editorialBlocks.filter(Boolean).forEach((block, index) => {
      const current = editorialStack.children[index] || null;
      if (current !== block) editorialStack.insertBefore(block, current);
    });

    if (gallery.parentElement !== productPage || gallery.nextElementSibling !== productText) {
      productPage.insertBefore(gallery, productText);
    }

    if (dataStack?.children.length === 0) dataStack.remove();
    if (mediaColumn?.children.length === 0) mediaColumn.remove();

    guide?.classList.add('fsm-guide-card--product-column');
    compatibility?.classList.add('fsm-product-compatibility');
    verdict?.classList.add('fsm-workshop-verdict--product-column');
    updateInformationVisibility();
  };

  const enhanceProductPage = (productPage) => {
    if (!productPage) return;

    const delivery = productPage.querySelector('[data-fsm-product-delivery]');
    const workshop = productPage.querySelector('.fsm-product-workshop-box');
    delivery?.closest('.card-widget')?.classList.add('fsm-block--delivery');
    workshop?.closest('.card-widget')?.classList.add('fsm-block--workshop');

    productPage.querySelectorAll('.product-variant').forEach((optionGroup) => {
      const items = optionGroup.querySelectorAll('.product-variant__item');
      if (items.length <= 1) {
        optionGroup.hidden = true;
        optionGroup.dataset.fsmSingleOption = '';
      }

      const optionName = optionGroup.querySelector('.product-variant__name')?.textContent || '';
      if (/ETRTO/i.test(optionName)) {
        optionGroup.querySelectorAll('.product-variant__input').forEach((input) => {
          const label = optionGroup.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          const conciseValue = input.value.match(/^\d{2,3}-\d{3}/)?.[0];
          if (label && conciseValue) {
            label.title = input.value;
            if (label.textContent.trim() !== conciseValue) label.textContent = conciseValue;
          }
        });
      }
    });

    const price = productPage.querySelector(':scope > .product-text > [data-update-block="price-compact"]');
    if (price && !price.querySelector('.fsm-price-note')) {
      const note = document.createElement('span');
      note.className = 'fsm-price-note';
      note.textContent = 'inkl. 19 % MwSt., zzgl. Versand';
      price.append(note);
    }

    const actions = productPage.querySelector('.product-actions');
    if (actions) actions.id = 'kauf';

    const description = productPage.querySelector('.product__description');
    if (description && !description.querySelector('.fsm-description-title')) {
      const title = document.createElement('h2');
      title.className = 'fsm-description-title';
      title.textContent = description.querySelector('[data-fsm-wolff-copy]')
        ? 'WOLFF Classic Fixie II: leichtes Singlespeed für die Stadt'
        : 'Beschreibung';
      description.prepend(title);
    }

    arrangeProductLayout(productPage);
    updateVariantContent(productPage);
  };

  const enhanceVariantFilters = () => {
    document.querySelectorAll('[data-fsm-variant-filter]').forEach((input) => {
      if (input.dataset.fsmReady) return;
      input.dataset.fsmReady = 'true';
      input.addEventListener('input', () => {
        const query = input.value.trim().toLocaleLowerCase('de');
        input.closest('[data-fsm-variant-table]')
          ?.querySelectorAll('[data-fsm-variant-row]')
          .forEach((row) => {
            row.hidden = query !== '' && !row.textContent.toLocaleLowerCase('de').includes(query);
          });
      });
    });
  };

  const enhanceAll = () => {
    document.querySelectorAll('.main-product').forEach(enhanceProductPage);
    enhanceVariantFilters();
  };

  const scheduleEnhancement = () => {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(() => {
      scheduled = false;
      enhanceAll();
    }, 0);
  };

  document.addEventListener('change', (event) => {
    const productPage = event.target.closest('.main-product');
    if (!productPage) return;

    const preferredVariantId = event.target.dataset.variantId || null;
    window.setTimeout(() => {
      updateVariantContent(productPage, preferredVariantId);
      scheduleEnhancement();
    }, 0);
    window.setTimeout(() => updateVariantContent(productPage), 180);
  });

  window.addEventListener('load', scheduleEnhancement, { once: true });
  window.addEventListener('resize', scheduleEnhancement);
  document.fonts?.ready.then(scheduleEnhancement);

  const observer = new MutationObserver(scheduleEnhancement);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll, { once: true });
  } else {
    enhanceAll();
  }
})();
